export const TERMINAL_TRANSACTION_STATUSES = new Set([
  "SUCCESS",
  "FAILED",
  "REVERSED",
]);
export const POLL_INTERVAL_MS = 3000;
export const POLL_TIMEOUT_MS = 45000;
export const OTP_INACTIVITY_TIMEOUT_MS = 90000;

export const PAYMENT_TYPES = {
  PAYBILL: "MPESA_PB",
  TILL_NUMBER: "MPESA_TN",
  B2B: "PAYKIT",
};

export const PAYMENT_TYPE_CONFIG = {
  [PAYMENT_TYPES.PAYBILL]: { label: "Paybill", rail: "M-Pesa" },
  [PAYMENT_TYPES.TILL_NUMBER]: { label: "Till Number", rail: "M-Pesa" },
  [PAYMENT_TYPES.B2B]: { label: "B2B Transfer", rail: "PayKit" },
};

export const PAYMENT_TYPE_HEADER = {
  [PAYMENT_TYPES.PAYBILL]: {
    title: "Paybill Payment",
    description: "Pay suppliers, utilities and businesses via M-Pesa Paybill",
  },
  [PAYMENT_TYPES.TILL_NUMBER]: {
    title: "Till Number Payment",
    description:
      "Pay suppliers, utilities and businesses via M-Pesa Till Number",
  },
  [PAYMENT_TYPES.B2B]: {
    title: "Paykit to Paykit Transfer",
    description: "Instant wallet-to-wallet transfer to other Paykit merchants",
  },
};
export const PAYMENT_TYPE_FIELD_CONFIG = {
  [PAYMENT_TYPES.PAYBILL]: {
    aliasLabel: "Paybill No.",
    watchFields: ["alias", "accountNumber", "amount"],
    aliasMinLength: 5,
    aliasMaxLength: 9,
    aliasNumericOnly: true,
  },
  [PAYMENT_TYPES.TILL_NUMBER]: {
    aliasLabel: "Till Number",
    watchFields: ["alias", "amount"],
    aliasMinLength: 5,
    aliasMaxLength: 9,
    aliasNumericOnly: true,
  },
  [PAYMENT_TYPES.B2B]: {
    aliasLabel: "Merchant Alias",
    watchFields: ["alias", "amount"],
    aliasMinLength: 1,
    aliasMaxLength: 250,
    aliasNumericOnly: false,
  },
};

export const LIPA_BIDHAA_STEPS = [
  { label: "Payment Details", description: "Enter payment info" },
  { label: "Review & Confirm", description: "Verify details" },
  { label: "Authorize", description: "Enter OTP" },
];

const PAYMENT_SUMMARY_BANNER =
  "Payment will be processed via M-Pesa. OTP verification required to authorize.";

export const PAYMENT_SUMMARY_DETAILS = {
  paymentSummary: {
    title: "Payment Summary",
    bannerMessage: PAYMENT_SUMMARY_BANNER,
  },
  transactionDetails: {
    title: "Transaction Details",
    bannerMessage: PAYMENT_SUMMARY_BANNER,
  },
};
